import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';
import {Observable} from 'rxjs';
import {OrganizationResponseModel} from '@core/modules/rest/organization/response/organization-response.model';
import {LanguageEnum} from '@core/enums/language.enum';
import {IndicationSimpleModel} from '@core/modules/rest/indication/response/indication-simple.model';

@Injectable({
    providedIn: 'root'
})
export class OrganizationRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/organization-group';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getOrganizations(language: LanguageEnum): Observable<OrganizationResponseModel[]> {
        return this.httpClient.get<OrganizationResponseModel[]>(this.controllerUrl.concat('/indications/').concat(language));
    }

    saveOrganizationIndications(indications: IndicationSimpleModel[], organizationId: string): Observable<void> {
        return this.httpClient.post<void>(this.controllerUrl.concat(`/indications/${organizationId}`), indications);
    }

}
